import React from "react";

import { ConfirmationWrapper } from "../../../../styled";

const BlankConfirmation = () => <ConfirmationWrapper />;

export default BlankConfirmation;
